import React from "react";

function Description() {
  return (
    <div className="description">
      Search for any <span className="highlight">emoji</span> from our
      collections.
      <div>
        You can <span className="highlight">search</span> for them or just{" "}
        <span className="highlight">browse </span>
        through the <div>emojis!</div>
      </div>
    </div>
  );
}

export default Description;
